import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const loadHomePage = async () => {
    const { Home } = await import('#pplx/frontend/apps/ask/page-components/home/index.js');
    return { default: Home };
};
const HomePagePreloader = Dynamic(loadHomePage);
export const preloadHomePage = HomePagePreloader.preload;
//# sourceMappingURL=HomePageRouteShared.js.map